import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

import Loader from "src/shared/Loader";
// import Breadcrumbs from "../components/Breadcrumbs";
import classes from "./MovieDetail.module.css";

import { MovieInfo } from "src/types/movieDetail";
import { dateFormat } from "src/utility";
import commonStyles from "src/assets/global_styles/commom.module.css";
import { getMovieDetail } from "src/shared/api";

const MovieDetail = () => {
  const [data, setData] = useState<MovieInfo | null>(null);
  let { id } = useParams();

  useEffect(() => {
    getMovieDetail(id).then((response) => setData(response.data));
  }, [id]);

  if (!data) {
    return <Loader />;
  }

  //Changing minutes format to hour and minutes
  const convertMinToHrs = (x: number) => {
    let hours = Math.floor(x / 60);
    let minutes = x % 60;

    return `${hours}hr ${minutes}min`;
  };

  return (
    <main className={classes.container}>
      {/*<Breadcrumbs movieName={data.title} />*/}
      <section className={classes.topSection}>
        <img
          className={classes.movieImage}
          alt="movie poster"
          src={`https://image.tmdb.org/t/p/w500${data.poster_path}`}
        />
        <div className={classes.movieInfo}>
          <h1 className={classes.title}>{data.title}</h1>
          <p className={classes.tagLine}>{data.tagline}</p>
          <span>
            <span className={commonStyles.bold}>Release date: </span>
            {dateFormat(data.release_date)}
          </span>
          <span className={classes.genreList}>
            <span className={commonStyles.bold}>Genre: </span>
            {data.genres.map((genre, index) => (
              <li>
                {genre.name}
                {index < data.genres.length - 1 && ","}
              </li>
            ))}
          </span>
          <span>
            <span className={commonStyles.bold}>Duration: </span>
            {convertMinToHrs(data.runtime)}
          </span>
        </div>
      </section>
      <section className={classes.bottomSection}>
        <p className={classes.overView}>{data.overview}</p>
      </section>
    </main>
  );
};

export default MovieDetail;
